var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 내 이미지 검출 레이아웃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }